import { lazy } from "react";
import { Navigate } from "react-router-dom";

// layout imports
import DashboardLayout from "layout/Dashboard";

// component imports
import Loadable from "components/Loadable";
import AuthGuard from "./AuthGuard";

// simulation module pages
const SimulationOverview = Loadable(
  lazy(() => import("~/modules/simulation/pages/SimulationOverview")),
);
const SimulationLaneDetail = Loadable(
  lazy(() => import("~/modules/simulation/pages/SimulationLaneDetail")),
);
const SimulationSettings = Loadable(
  lazy(() => import("~/modules/simulation/pages/SimulationSettings")),
);

// Validations module pages
const ValidationsDashboard = Loadable(
  lazy(() => import("~/modules/validations/pages/ValidationsDashboard")),
);
const TransactionsList = Loadable(
  lazy(() => import("~/modules/validations/pages/TransactionsList")),
);
const PlateValidationModule = Loadable(
  lazy(() => import("~/modules/validations/pages/PlateValidation")),
);
const VehicleValidation = Loadable(
  lazy(() => import("~/modules/validations/pages/VehicleValidation")),
);
const PlateDetails = Loadable(
  lazy(() => import("~/modules/validations/pages/PlateDetails")),
);

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  children: [
    {
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="/validations" replace />,
        },
        {
          path: "validations",
          element: <ValidationsDashboard />,
        },
        {
          path: "validations/transactions",
          element: <TransactionsList />,
        },
        {
          path: "validations/plate-validation",
          element: <PlateValidationModule />,
        },
        {
          path: "validations/vehicle-validation",
          element: <VehicleValidation />,
        },
        {
          path: "validations/plate-details",
          element: <PlateDetails />,
        },
        {
          path: "simulation",
          element: <SimulationOverview />,
        },
        {
          path: "simulation/lane/:laneId",
          element: <SimulationLaneDetail />,
        },
        {
          path: "simulation/settings",
          element: <SimulationSettings />,
        },
      ],
    },
  ],
};

export default MainRoutes;
